import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import Avatar from '../../Avatar';
import { dateFormat } from '../../../config';

import cs from '../../commonStyle.css'
import s from '../ViewMessage.css';

const ToMessage = (props) => {

  const { profileId, picture, displayName, content, createdAt } = props;
  let date = createdAt != null ? moment(parseInt(createdAt)).format('L') : '';

  return (
    <div className={cx(s.messageMainContainer, cs.spaceBottom4)}>
      <div className={cx(s.rsFromMessageContainer, s.rsFromMessageMarginRight, 'rsFromMessageContainerRTL', 'rsFromMessageMarginRightRLT')}>
        <div className={cx()}>
          <span className={cx(s.messageText)}>
            {
              content && (content.trim()).split("\n").map(function (item, index) {
                return (
                  <span key={index}>{item}<br /></span>
                )
              })
            }
          </span>
          <div className={cx(s.dateText, s.spaceTop1)}>
            <span>{date}</span>
          </div>
        </div>
      </div>
      <div className={cx(s.lsMessageContainer)}>
        <div className={s.messageAvatar}>
          <Avatar
            source={picture}
            title={displayName}
            className={s.profileAvatar}
            withLink
            linkClassName={s.commonProfileAvatarLink}
            profileId={profileId}
          />
        </div>
      </div>
    </div>
  );
}


ToMessage.propTypes = {
  profileId: PropTypes.number.isRequired,
  picture: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  content: PropTypes.string,
  createdAt: PropTypes.string.isRequired
};

ToMessage.defaultProps = {
  createdAt: null
};

export default withStyles(cs, s)(ToMessage);
